import React from "react";
import { Timeline, Collapse, Typography } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
const { Panel } = Collapse;
const { Text } = Typography;
const InfoDetail = (props) => {
  const { title, detail, component } = props;
  return (
    <div className="info_detail">
      <div className="info_detail_title">
        <Text type="secondary">{title}</Text>
      </div>
      {component ? (
        component
      ) : (
        <Text className="info_detail_text">{detail}</Text>
      )}
    </div>
  );
};
export default InfoDetail;
